import ROUTE_NAMES from '@/app/admin/router/router-const'
export default [
  {
    path: 'exercise',
    name: ROUTE_NAMES.LOGIN_EXERCISE,
    component: () => import('../ExerciseLoginPage.vue'),
  }
]